import seo from '../app/app/json/seo.json'

const fallback = {
  title: process.env.VITE_NAME || 'TrueCurrent',
  description:
    'Trade on TrueCurrent - the premier decentralized spot and derivatives exchange with low fees and gas free execution',
  keywords:
    'injective protocol, dapp, decentralized app, cryptocurrency, cryptocurrency exchange, exchange, ethereum, erc20, futures, perpetuals, futures protocol, cosmos, spot trading, derivatives, injective, ibc, cross-chain',
  url: 'https://app.tc.xyz',
  ogImage: `${process.env.VITE_BASE_URL || 'https://app.tc.xyz'}/images/og-true-current.png`
}

const ogImage = seo.openGraph?.image || seo.metaImage

export const metaTags = {
  shortName: 'TC',
  author: 'TrueCurrent',
  twitterHandle: '@TrueCurrentX',
  ogImageAlt: ogImage?.alt ?? null,
  title: seo.title || fallback.title,
  ogImageWidth: ogImage?.width ?? null,
  ogImageHeight: ogImage?.height ?? null,
  canonicalURL: seo.canonicalURL || null,
  ogType: seo.openGraph?.type || 'website',
  ogImage: ogImage?.url || fallback.ogImage,
  keywords: seo.keywords || fallback.keywords,
  description: seo.description || fallback.description,
  url: (seo.openGraph?.url || seo.canonicalURL || fallback.url).replace(
    /\/+$/,
    ''
  )
}

export const nuxtMetaTags = [
  {
    hid: 'og:url',
    property: 'og:url',
    content: metaTags.url
  },
  { hid: 'keywords', name: 'keywords', content: metaTags.keywords },
  { hid: 'description', name: 'description', content: metaTags.description },
  { hid: 'author', name: 'author', content: metaTags.author },
  { hid: 'og:type', property: 'og:type', content: metaTags.ogType },
  {
    hid: 'og:image',
    property: 'og:image',
    content: metaTags.ogImage
  },
  ...(metaTags.ogImageWidth
    ? [
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: String(metaTags.ogImageWidth)
        }
      ]
    : []),
  ...(metaTags.ogImageHeight
    ? [
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: String(metaTags.ogImageHeight)
        }
      ]
    : []),
  ...(metaTags.ogImageAlt
    ? [
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: metaTags.ogImageAlt
        }
      ]
    : []),
  {
    hid: 'og:description',
    property: 'og:description',
    content: metaTags.description
  },
  {
    hid: 'twitter:card',
    property: 'twitter:card',
    content: 'summary_large_image'
  },
  {
    hid: 'twitter:site',
    property: 'twitter:site',
    content: metaTags.twitterHandle
  },
  {
    name: 'twitter:image',
    content: metaTags.ogImage
  },
  {
    hid: 'twitter:creator',
    property: 'twitter:creator',
    content: metaTags.twitterHandle
  },
  {
    hid: 'twitter:description',
    property: 'twitter:description',
    content: metaTags.description
  },
  {
    hid: 'twitter:title',
    property: 'twitter:title',
    content: metaTags.title
  },
  { hid: 'og:title', property: 'og:title', content: metaTags.title },
  { hid: 'og:site_name', property: 'og:site_name', content: metaTags.title },
  { hid: 'title', property: 'title', content: metaTags.title }
  // {
  //   hid: 'apple-itunes-app',
  //   name: 'apple-itunes-app',
  //   content: 'app-id=6737353178'
  // }
]
